import React, { Component } from 'react';
import './HeaderTool.css';
import { NavLink, Link } from 'react-router-dom';
import profile from '../../../image/personlg.svg'
class HeaderTool extends Component {
    constructor(){
        super();

        this.state = {
            block: false
        }
    }
    changeColor(){
        this.setState({block: !this.state.block})
     }
     Logout=()=>{
        localStorage.removeItem("KaynuserName")
        localStorage.removeItem("userToken")
        localStorage.removeItem("userTokentConfirmData")
        window.location.replace("/Signin")
     }
    render() {
        const Name = localStorage.getItem("KaynuserName")
 
        return (
            <div className="HeaderTool text-right px-3">
                <ul className="nav text-center ">
                    <li className="nav-item dropdown select  ">
                        <a className="nav-link text-left clearfix" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                            <img className="mx-3 imagprofile" src={profile} alt="profile" />
                        </a>
                        <div className="dropdown-menu m-0 p-3">
                            <p className="dropdown-item p-0" href="#">Hallo, {Name}</p><hr />
                            <Link to="/Profile" className="dropdown-item" >Profile</Link>
                            <Link  to={"/AR"+window.location.pathname}className="dropdown-item">AR</Link>

                            <p className="dropdown-item" onClick={this.Logout} >Log Out</p>
                        </div>
                    </li>
                </ul>
               
                  <button className="d-lg-none d-md-none d-sm-block btn float-left fixed-top btnminu" onClick={this.changeColor.bind(this)}>&#9776;</button>
                  <div className={"sidebar d-lg-none d-md-none  d-sm-block  shadow "+( this.state.block ? "sidebarblock" : "sidebarnone")} >
                    <ul className="navbar-nav sticky-top text-uppercase iconsnavclient">
                    <button className="d-lg-none  d-md-none d-sm-block btn float-left fixed-top btnminu" onClick={this.changeColor.bind(this)}>&#9776;</button>

                    
                        <li className="nav-item ">
                            <NavLink to="/NewOrder" className="iconnav "><div className="iconneworder mx-auto"></div><p className="fontsize15">New Order</p></NavLink>
                        </li>                            

                        <li className="nav-item ">
                            <NavLink to="/Orders" className="iconnav "><div className="iconorders  mx-auto">  </div><p className="fontsize15">Orders</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/MyClients" className="iconnav "><div className="iconclient  mx-auto"></div><p className="fontsize15">MyClients</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/ClientAdderss" className="iconnav "><div className="iconaddressbook   mx-auto"></div><p className="fontsize15">Client Adderss</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Wallet" className="iconnav "><div className="iconwallet  mx-auto"></div><p className="fontsize15">Wallet</p></NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}
export default HeaderTool;